import { useIntl } from 'react-intl'
import { SelectButton } from 'primereact/selectbutton'
import { UrgencyMeasure, URGENCY_MEASURES } from '../urgencyAnalysis'

interface UrgencyMeasureSelectorProps {
  value: UrgencyMeasure
  onChange: (measure: UrgencyMeasure) => void
}

const MEASURE_LABEL_ID: Record<UrgencyMeasure, string> = {
  arrivals: 'UrgencySummaryMeasureArrivals',
  wait: 'UrgencySummaryMeasureWait',
}

/**
 * «Medir por»: el mismo dato del gráfico en otra medida (llegadas o espera), por eso es un SelectButton y no pestañas. La
 * frase «Medir por» no se ve (el título del gráfico cambia con la medida): queda como nombre accesible del grupo.
 */
export default function UrgencyMeasureSelector({ value, onChange }: UrgencyMeasureSelectorProps) {
  const intl = useIntl()
  const options = URGENCY_MEASURES.map((measure) => ({ value: measure, label: intl.formatMessage({ id: MEASURE_LABEL_ID[measure] }) }))
  return (
    <SelectButton
      value={value}
      options={options}
      optionLabel="label"
      optionValue="value"
      onChange={(event) => { if (event.value) onChange(event.value as UrgencyMeasure) }}
      aria-label={intl.formatMessage({ id: 'UrgencySummaryMeasureBy' })}
    />
  )
}
